<sk-wave [color]="color"></sk-wave>



// WEBPACK FOOTER //
// ./src/app/components/spinner/spinner.component.html